import { Component, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { WpApprovalService } from './wp-approval.service';
import { environment } from '../../../environments/environment';

interface User {
  name: string;
  image: string;
}

@Component({
  selector: 'app-wp-approval',
  templateUrl: './wp-approval.component.html',
  styleUrl: './wp-approval.component.css',
})
export class WpApprovalComponent {
  approvalList = `${environment.opbBackendHost}/api/admin/approval/list`;

  users: any[];

  private wpApprovalService = inject(WpApprovalService);
  userPayload: any;

  ngOnInit(): void {
    this.getList();
  }

  onDataLoaded(data: any) {
    this.users = data;
  }

  getList() {
    this.userPayload = { start: '0', page: 1 };
    this.wpApprovalService.getList(this.userPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.users = parsedData.data || [];
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  updateState(data: any) {
    this.users = this.users.filter(
      (wp: any) =>
        wp?.workpackage_id != data?.workpackage_id
    );
  }
}
